import React, { memo } from 'react';
import PropTypes from 'prop-types';

import styles, { mainCls } from './style';
import createStyle from 'shared-utils/src/createStyle';
import makeClassName from 'shared-utils/src/makeClassName';

import footerLinks from 'shared-constants/src/header_footer/footerLinks';
import socialLinks from 'shared-constants/src/header_footer/socialLinks';

const useStyles = createStyle(styles);

const propTypes = {
  domain: PropTypes.string,
  scrollInfos: PropTypes.instanceOf(Object),
  footerIsVisible: PropTypes.func,
  is404: PropTypes.bool,
  customSiteLinks: PropTypes.instanceOf(Array),
  visible: PropTypes.bool,
	refEl: PropTypes.func,
  fromPortal: PropTypes.bool,
};
const defaultProps = {
  domain: null,
  scrollInfos: { coords: null, dir: '' },
  footerIsVisible: () => {},
  is404: false,
  customSiteLinks: null,
  visible: false,
	refEl: null,
  fromPortal: false,
};
export const Footer = ({
  domain,
  is404,
  customSiteLinks,
  visible,
	refEl,
  fromPortal,
}) => {

  const elRef = refEl;
  const baseUrl = fromPortal
    ? ''
    : domain || 'https://www.casa.it';
  const siteLinks = customSiteLinks || footerLinks;

  const cls = useStyles();
  const footerCls = makeClassName([
    cls[mainCls],
    'tp-w--m',
    'c-txt--w',
    'c-bg--secondary',
    'c-br--primary',
    visible && 'isVisible',
    is404 && cls[`${mainCls}--is404`],
  ]);
  const shareInfosCls = makeClassName([
    cls[`${mainCls}__share_infos`],
    siteLinks.length > 9 && 'fourLines',
  ]);
  const infosCls = makeClassName([
    cls[`${mainCls}__infos`],
    'tp-s--xs',
  ]);

  return (
    <footer ref={elRef} className={footerCls}>
      <div className={cls[`${mainCls}__ctn`]}>
        <div className={cls[`${mainCls}__links`]}>
          <div className={cls[`${mainCls}__links--cnt`]}>
            {
              siteLinks.map(
                (link) => {
                  if (!link.label) {
                    return (
                      <span
                        key={`${link.cssClass}__siteLinks`}
                        className={cls[`${mainCls}__links--cnt--${link.cssClass}`]}
                      />
                    );
                  }

                  const linkUrl = link.url || '';

                  let href = linkUrl.indexOf('http') === 0 // se inizia con http
                    ? linkUrl
                    : `${baseUrl}${linkUrl}`;

                  if (!href) {
                    href = '/'
                  }

                  return (
                    <a
                      key={`${link.url}__siteLinks`}
                      href={href}
                      title={link.altText}
                      className={`${cls[`${mainCls}__links--cnt--${link.cssClass}`]} c-txt--w`}
                      rel={link.rel}
                      target={link.target}
                      onClick={link.action || null}
                    >
                      {link.label}
                    </a>
                  );
                }
              )
            }
          </div>
        </div>
        <div className={shareInfosCls}>
          <div className={cls[`${mainCls}__share`]}>
            {
              socialLinks.map(
                (link) => (
                  <a
                    key={`${link.url}__socialLinks`}
                    href={link.url}
                    title={link.altText}
                    className={link.class}
                    rel={link.rel}
                    target={link.target}
                  >
                    {link.altText}
                  </a>
                )
              )
            }
          </div>
          <div className={infosCls}>
            Copyright ©{new Date().getFullYear()} Casa.it - Tutti i diritti riservati
          </div>
        </div>
      </div>
    </footer>
  );
};
Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;
const shouldUpdate = (prevProps, nextProps) => prevProps.visible === nextProps.visible;
export default memo(Footer, shouldUpdate);